import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "components/navbar";
import Sidebar from "components/sidebar";
import Footer from "components/footer/Footer";
// import routes from "routes.js";
import useRoutes from "config/useRoutes";

import { useSelector } from "react-redux";
import ViewUser from "views/admin/Users/ViewUser/ViewStore";
import ViewStore from "views/admin/storeManagement/ViewStore/ViewStore";
import ViewLaundryMan from "views/admin/laundrymanManagement/ViewLaundryMan/ViewLaundryMan";
import ViewLaundry from "views/admin/mainlaundryManagement/ViewLaundry/ViewLaundry";
import ViewCoupon from "views/admin/couponmanagement/ViewCoupon/ViewCoupon";
import ViewPlan from "views/admin/planesManagement/ViewPlan/ViewPlan";
import ViewRole from "views/admin/roleManagement/ViewRole/ViewRole";
import ViewCatagory from "views/admin/catagorymanagemnt/ViewCatagory/ViewCatagory";
import ViewItem from "views/admin/itemManagement/ViewItem/ViewItem";
import ViewItemService from "views/admin/itemServicesManagement/ViewItem/ViewItem";
import EditUser from "views/admin/Users/EditUser";
import EditStore from "views/admin/storeManagement/EditStore";
import EditLaundryMan from "views/admin/laundrymanManagement/EditLaundryMan";
import EditLaundry from "views/admin/mainlaundryManagement/EditLaundry";
import EditCoupon from "views/admin/couponmanagement/EditCoupon";
import EditPlan from "views/admin/planesManagement/EditPlan";
import EditRole from "views/admin/roleManagement/EditRole";
import EditCatagory from "views/admin/catagorymanagemnt/EditCatagory";
import EditItem from "views/admin/itemManagement/EditItem";
import EditItemService from "views/admin/itemServicesManagement/EditItemService";
import ViewLaundryBox from "views/admin/laundryBoxmanagement/ViewLaundryBox/ViewLaundryBox";
import EditLaundryBox from "views/admin/laundryBoxmanagement/EditLaundryBox";
import ViewOrder from "views/admin/orderManagement/ViewOrder/ViewOrder";
import EditOrder from "views/admin/orderManagement/EditOrder";
import ViewReports from "views/admin/reportGeneration/ViewReports/ViewReports";
import ViewOffer from "views/admin/offersmanagement/ViewOffer/ViewOffer";
import EditOffer from "views/admin/offersmanagement/EditOffer";
import EditArea from "views/admin/areamanagement/EditArea";
import ViewArea from "views/admin/areamanagement/ViewArea/ViewArea";
import ViewDeleveryCharge from "views/admin/deleverycharges/ViewDeleveryCharge/ViewDeleveryCharge";
import EditDeleveryCharge from "views/admin/deleverycharges/EditDeleveryCharge";
import ViewUpdated from "views/admin/orderManagement/ViewOrder/ViewUpdated";
import EditOrderUpdated from "views/admin/orderManagement/EditOrder/EditOrderUpdated";
import ViewLaundryBoxOrder from "views/admin/orderManagement/ViewLaundryBox/ViewLaundryBoxOrder";
import ViewTax from "views/admin/taxManagement/ViewTax/ViewTax";
import EditTax from "views/admin/taxManagement/EditTax";
import ViewFaq from "views/admin/Faqs/ViewFaq";
import EditFaq from "views/admin/Faqs/EditFaq";
import { useTranslation } from "react-i18next";

export default function Admin(props) {
  const routes = useRoutes();

  const { ...rest } = props;
  const location = useLocation();
  const [open, setOpen] = React.useState(true);
  const [currentRoute, setCurrentRoute] = React.useState("Main Dashboard");
  const language = useSelector((state) => state?.user?.language);
const {t} = useTranslation();

  React.useEffect(() => {
    window.addEventListener("resize", () =>
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
    );
  }, []);
  React.useEffect(() => {
    getActiveRoute(routes);
  }, [location.pathname,routes]);

  const getActiveRoute = (routes) => {
    let activeRoute = "Main Dashboard";
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(
          routes[i].layout + "/" + routes[i].path
        ) !== -1
      ) {
        setCurrentRoute(routes[i].name);
      }
    }
    return activeRoute;
  };
  const getActiveNavbar = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
      ) {
        return routes[i].secondary;
      }
    }
    return activeNavbar;
  };
  // const getRoutes = (routes) => {
  //   console.log("inside", routes);
  //   return routes.map((route, key) => {
  //     console.log("inside..", routes);

  //     if (route.layout === "/admin") {
  //       return (
  //         <Route
  //           key={key}
  //           path={`${route.layout}/${route.path}`}
  //           element={route.component}
  //         >
  //           {route.children &&
  //             route.children.map((childRoute, childKey) => (
  //               <Route
  //                 key={childKey}
  //                 path={`${route.layout}/${route.path}/${childRoute.path}`}
  //                 element={childRoute.component}
  //               />
  //             ))}
  //         </Route>
  //       );
  //     }
  //     return null;
  //   });
  // };
  // const getRoutes = (routes) => {
  //   return routes.map((route, key) => {
  //     if (route.layout === "/admin") {
  //       return (
  //         <Route
  //           key={key}
  //           path={`${route.layout}/${route.path}`}
  //           element={route.component}
  //         >
  //           {route.children && route.children.map((childRoute, childKey) => (
  //             <Route
  //               key={childKey}
  //               path={`${route.layout}/${route.path}/${childRoute.path}`}
  //               element={childRoute.component}
  //             />
  //           ))}
  //         </Route>
  //       );
  //     }

  //     // Handle other layouts or return null if not applicable
  //     return route.layout && route.layout !== "/admin" ? (
  //       <Route
  //         key={key}
  //         path={route.layout + "/" + route.path} // Adjust path construction if needed
  //         element={route.component}
  //       />
  //     ) : null;
  //   });
  // };

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key}>
            {prop.children &&
              prop.children.map((childRoute, childKey) => (
                <Route
                  key={childKey}
                  path={`${childRoute.path}`}
                  element={childRoute.component}
                />
              ))}
          </Route>
        );
      } else {
        return null;
      }
    });
  };

  document.documentElement.dir = "ltr";
  console.log("routes ==>", routes);
  return (
    <>

    <div className="flex h-full w-full">
      <Sidebar open={open} onClose={() => setOpen(false)} />
      {/* Navbar & Main Content */}
      <div className="h-full w-full bg-lightPrimary dark:!bg-navy-900">
        {/* Main Content */}
        <main
          // className={`${language === 'ar' ? "xl:mr-[330px]" : "xl:ml-[330px]" }  mx-[12px] h-full flex-none transition-all md:pr-2`}
          className={`${
            language === "ar" ? "xl:mr-[330px]" : "xl:ml-[240px]"
          }  mx-[12px] h-full flex-none transition-all md:pr-2`}
        >
          {/* Routes */}
          <div className="ml-3 h-full">
            <Navbar
              onOpenSidenav={() => setOpen(true)}
              logoText={t("Iwash")}
              brandText={currentRoute}
              secondary={getActiveNavbar(routes)}
              open={open}
              {...rest}
            />
            {/* pt-5s */}
            <div className=" mx-auto mb-auto h-full min-h-[84vh] p-2 md:pr-2">
              <Routes>
                {getRoutes(routes)}

                <Route
                  path="/"
                  element={<Navigate to="/admin/dashboared" replace />}
                />
                <Route path="lusers/:userId" element={<ViewUser />} />
                <Route path="store-management/:id" element={<ViewStore />} />
                <Route
                  path="laundryman-management/:id"
                  element={<ViewLaundryMan />}
                />

                <Route
                  path="main-laundry-management/:id"
                  element={<ViewLaundry />}
                />
                <Route
                  path="main-coupon-management/:id"
                  element={<ViewCoupon />}
                />
                <Route path="offer-management/:id" element={<ViewOffer />} />
                <Route
                  path="deliverycharges/:id"
                  element={<ViewDeleveryCharge />}
                />

                <Route path="plan-management/:id" element={<ViewPlan />} />
                <Route path="tax/:id" element={<ViewTax />} />

                <Route path="role/:id" element={<ViewRole />} />
                <Route path="faq/:id" element={<ViewFaq />} />

                <Route path="area/:id" element={<ViewArea />} />

                <Route path="reports/:id" element={<ViewReports />} />

                <Route path="catagory/:id" element={<ViewCatagory />} />
                <Route path="items/:id" element={<ViewItem />} />
                <Route path="item-services/:id" element={<ViewItemService />} />

                <Route path="laundry-box/:id" element={<ViewLaundryBox />} />

                {/* <Route path="order-management/:id" element={<ViewOrder />} /> */}
                <Route path="order-management/:id" element={<ViewUpdated />} />
                <Route
                  path="order-management/view-laundrybox-order/:id"
                  element={<ViewLaundryBoxOrder />}
                />

                {/* For Edit things */}
                <Route path="tax/edit/:id" element={<EditTax />} />
                <Route
                  path="laundry-box/edit/:id"
                  element={<EditLaundryBox />}
                />
                <Route path="faq/edit/:id" element={<EditFaq />} />
                {/* <Route
                  path="order-management/edit/:id"
                  element={<EditOrder />}
                /> */}
                <Route
                  path="order-management/edit/:id"
                  element={<EditOrderUpdated />}
                />

                <Route path="lusers/edit/:id" element={<EditUser />} />
                <Route
                  path="deliverycharges/edit/:id"
                  element={<EditDeleveryCharge />}
                />

                <Route
                  path="store-management/edit/:id"
                  element={<EditStore />}
                />
                <Route
                  path="laundryman-management/edit/:id"
                  element={<EditLaundryMan />}
                />

                <Route
                  path="main-laundry-management/edit/:id"
                  element={<EditLaundry />}
                />
                <Route
                  path="main-coupon-management/edit/:id"
                  element={<EditCoupon />}
                />
                <Route
                  path="offer-management/edit/:id"
                  element={<EditOffer />}
                />
                <Route path="plan-management/edit/:id" element={<EditPlan />} />
                <Route path="role/edit/:id" element={<EditRole />} />
                <Route path="area/edit/:id" element={<EditArea />} />

                <Route path="catagory/edit/:id" element={<EditCatagory />} />
                <Route path="items/edit/:id" element={<EditItem />} />
                <Route
                  path="item-services/edit/:id"
                  element={<EditItemService />}
                />
              </Routes>
            </div>
            <div className="p-3">
              <Footer />
            </div>
          </div>
        </main>
      </div>
    </div>
    </>
  );
}
